import React from 'react';

const HoverRevealBox = ({ imageSrc, label, preview, forcePreview }) => {
  return (
    <div className={`box ${preview ? 'preview' : ''}`}>
      <img className={`abs-img ${forcePreview? 'hover-preview' : ''} `} src={imageSrc} alt={label} />
      <label>
        {label.split("\n").map((line, index) => (
          <React.Fragment key={index}>
            {line}
            <br />
          </React.Fragment>
        ))}
      </label>
      <hr />
    </div>
  );
};

export default HoverRevealBox;
